import axios from "axios";
import { SERVICEURL } from "../appconfig";

export interface GetAddressDetailResponse {
  addressID: string;
  addressLine: string;
  cityName: string;
  countryID?: string;
  cityID?: string;
  townID?: string;
  communicationParameterID?: string;
  postcode: string;
}

// ce90f95: adres metni zorunlu degil -- bos birakilirsa acikca null gonderilip sunucuda
// AddressInfo.AddressLine NULL'a cekiliyor. Karsilik gelen BE alani `string?`
// (Wiser-ATS-BE/DTO/CandidatesDTO/AddressInfoListDTO.cs, UpdateAddressInfoRequestDTO).
export interface UpdateAddressPayload {
  addressID: string;
  addressLine: string | null;
  cityName: string | null;
  countryID?: string;
  cityID?: string;
  // ce90f95: ilce bos birakilabilir; acik null ile kolon temizlenir.
  townID?: string | null;
  communicationParameterID?: string;
  postcode: string;
}

export const getAddressDetail = async (
  id: string
): Promise<GetAddressDetailResponse> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${SERVICEURL}api/Candidates/GetAddressDetail/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const rawData = response.data?.data || response.data;

  const findField = (obj: any, fieldName: string) => {
    const key = Object.keys(obj).find(
      (k) => k.toLowerCase() === fieldName.toLowerCase()
    );
    return key ? obj[key] : undefined;
  };

  const asOptionalString = (value: unknown) =>
    value != null && value !== "" ? String(value) : undefined;

  return {
    addressID: String(findField(rawData, "addressid") ?? ""),
    addressLine: findField(rawData, "addressline") ?? "",
    cityName: findField(rawData, "cityname") ?? "",
    countryID: asOptionalString(findField(rawData, "countryid")),
    cityID: asOptionalString(findField(rawData, "cityid")),
    townID: asOptionalString(findField(rawData, "townid")),
    communicationParameterID: asOptionalString(
      findField(rawData, "communicationparameterid")
    ),
    postcode: findField(rawData, "postcode") ?? "",
  };
};

export const updateAddressInfo = async (
  payload: UpdateAddressPayload
): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.put(`${SERVICEURL}api/Candidates/UpdateAddressInfo`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteAddressInfo = async (addressId: string): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(
    `${SERVICEURL}api/Candidates/DeleteAddressInfo/${addressId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
